import { ColDef, ValueFormatterParams } from 'ag-grid-enterprise';
import { FundGetData } from '~/api/def/endpoints/fundEndpoint';
import { CallbackOnCLick } from '~/components/ui/tables/ag/cellRenderers/CallbackOnCLick';
import { formatCurrency } from '~/lib/money';

export const colDefsLinkedDocumentsGet = (callbacks: {
  onFund: (fund: FundGetData) => void;
}): ColDef<FundGetData>[] => {
  return [
    {
      field: 'name',
      headerName: 'Name',
      sortable: true,
      cellClass: 'flex align-items-center justify-content-left',
      type: 'w120',
      filter: true,
      flex: 2,
      maxWidth: 450,
      cellRenderer: (p: { value: string; data: FundGetData }) =>
        CallbackOnCLick({
          ...p,
          cb: callbacks.onFund,
        }),
    },
    {
      field: 'inceptionDate',
      headerName: 'Vintage Year',
      sortable: true,
      filter: true,
      cellClass: 'flex align-items-center',
      valueFormatter: (p: ValueFormatterParams<FundGetData, string>) =>
        p.value ? new Date(p.value).getFullYear().toString() : '-',
    },
    {
      field: 'currentNav',
      suppressHeaderMenuButton: true,
      headerName: 'AUM',
      maxWidth: 120,
      sortable: true,
      cellClass: 'flex align-items-center justify-content-center',
      filter: true,
      valueFormatter: (p: ValueFormatterParams<FundGetData, number>) => {
        return typeof p.value === 'number'
          ? formatCurrency(p.data?.currency ?? 'EUR', p.value)
          : '';
      },
    },
    {
      field: 'assetDeployed',
      headerName: 'Total Asset Deployed',
      sortable: true,
      filter: true,
      cellClass: 'flex align-items-center justify-content-center',
      suppressHeaderMenuButton: true,
      valueFormatter: (p: ValueFormatterParams<FundGetData, number>) => {
        return typeof p.value === 'number'
          ? formatCurrency(p.data?.currency ?? 'EUR', p.value)
          : '';
      },
    },
    {
      field: 'portfolioCompanyCount',
      headerName: 'No of Portfolio Companies',
      sortable: true,
      filter: true,
      cellClass: 'flex align-items-center justify-content-center',
      suppressHeaderMenuButton: true,
    },
    {
      field: 'investmentFocus',
      headerName: 'Investment Focus',
      cellClass: 'flex align-items-center justify-content-center',
      sortable: true,
      filter: true,
    },
    {
      field: 'status',
      filter: true,
      headerName: 'Status',
      cellClass: 'flex align-items-center',
      sortable: true,
      resizable: false,
      maxWidth: 120,
    },
    {
      field: 'irr',
      filter: true,
      headerName: 'IRR',
      cellClass: 'flex align-items-center',
      sortable: true,
      resizable: false,
      maxWidth: 120,
    },
  ];
};
